import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const CalendarIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox={`0 0 24 24`}
        >
            <title>Calendar Icon</title>
            <path
                className={fillStyles}
                d="M23 21c0 1.103-.896 2-2 2H3c-1.103 0-2-.897-2-2V5.5c0-1.103.897-2 2-2h2v1C5 5.325 5.676 6 6.5 6h1C8.325 6 9 5.325 9 4.5v-1h6v1c0 .825.676 1.5 1.5 1.5h1c.825 0 1.5-.675 1.5-1.5v-1h2c1.104 0 2 .897 2 2V21zM6 1.5c0-.271.229-.5.5-.5h1c.271 0 .5.229.5.5v3c0 .271-.229.5-.5.5h-1c-.271 0-.5-.229-.5-.5v-3zm10 0c0-.271.229-.5.5-.5h1c.271 0 .5.229.5.5v3c0 .271-.229.5-.5.5h-1c-.271 0-.5-.229-.5-.5v-3zM7.5 0C8.325 0 9 .675 9 1.5v1h6v-1c0-.825.676-1.5 1.5-1.5h1c.825 0 1.5.675 1.5 1.5v1h2c1.65 0 3 1.35 3 3V21c0 1.65-1.35 3-3 3H3c-1.649 0-3-1.35-3-3V5.5c0-1.65 1.351-3 3-3h2v-1C5 .675 5.676 0 6.5 0zM23 9H1v1h22V9z"
                fillRule="evenodd"
            />
        </svg>
    );
};
